/* HDD 布光面板 */
import {
    Dropdown,
    Space,
    Menu,
    Slider,
    Collapse,
    Switch,
    InputNumber,
} from 'antd';
import { DownOutlined, CaretRightOutlined } from '@ant-design/icons';
import { throttle } from '&/utils/common';
import usePreventDefault from '@/utils/customHooks/usePreventDefault';
import squireIcon from '@/assets/img/hdd/squire.png';
import areaIcon from '@/assets/img/hdd/area.png';
import pointIcon from '@/assets/img/hdd/point.png';
import spotIcon from '@/assets/img/hdd/spoint.png';
import { getCondition } from '@/api/hdd/leftPanel';

import './lighting.scss';
import { useEffect } from 'react';

const { Panel } = Collapse;

let draggingElevation = false;

export default function Lighting() {
    const [selectMenu, setSelectMenu] = useState('1');

    const [lightList, setLightList] = useState([]);

    const [lightNames, setLightNames] = useState([]);

    const switchLight = useRef(0);

    let version = new URLSearchParams(window.location.search).get('version');

    let versionFlag = false;

    if (version) {
        versionFlag = version.split('.').join('') >= 2100000;
    }

    usePreventDefault();

    const marks = {
        2000: {
            style: { transform: 'translateX(0%)', left: '0%' },
            label: '红日',
        },
        6500: { style: {}, label: '正午' },
        15000: {
            style: { transform: 'translateX(-100%)', left: '100%' },
            label: '月光',
        },
    };

    const shadowMarks = {
        0.1: {
            style: { transform: 'translateX(0%)', left: '0%' },
            label: '锐利',
        },
        2: {
            style: { transform: 'translateX(-100%)', left: '100%' },
            label: '柔和',
        },
    };

    const onMenuClick = ({ key }) => {
        isFromHDDActive.current = false;
        setSelectMenu(key);
        const params = lightList.find(v => v.id === key);
        initLight(params);
        switchLight.current = 1;
    };

    const menu = (
        <Menu onClick={onMenuClick} selectedKeys={selectMenu}>
            {lightList.map(v => {
                return <Menu.Item key={v.id}>{v.name}</Menu.Item>;
            })}
        </Menu>
    );

    const lightTypes = [
        {
            name: '矩形面光',
            type: '1',
            id: '1',
            img: squireIcon,
        },
        {
            name: '圆形面光',
            id: '2',
            type: '2',
            img: areaIcon,
        },
        {
            name: '点光源',
            id: '3',
            type: '3',
            img: spotIcon,
        },
        {
            name: '聚光灯',
            id: '4',
            type: '4',
            img: pointIcon,
        },
    ];

    const handleLightMousedown = (e, item) => {
        e.preventDefault();
        try {
            let obj = {
                type: item.type,
                id: item.id,
                name: item.name,
                intensity: item.intensity,
                iesFile: item.iesFile,
            };
            console.log('鼠标按下', console.log(obj));
            window.external.DispatchFun(
                'LeftPanel',
                'clickLight',
                JSON.stringify(obj)
            );
            window.external.DispatchFun('LeftPanel', 'MouseLeftDown', '');
        } catch (e) {}
    };

    const handleLightMouseup = e => {
        e.preventDefault();
        try {
            console.log('鼠标弹起');
            window.external.DispatchFun('LeftPanel', 'MouseLeftUp', '');
        } catch (e) {}
    };

    const baseLighting = (
        <>
            {lightTypes.map(v => {
                return (
                    <div
                        className="lighting-wrap"
                        key={v.id}
                        onMouseDown={e => handleLightMousedown(e, v)}
                        onMouseUp={handleLightMouseup}>
                        <img src={v.img}></img>
                        <div className="light-name">{v.name}</div>
                    </div>
                );
            })}
        </>
    );

    const [sunLightCheck, setSunLightCheck] = useState(true);

    const initLight = params => {
        if (params) {
            setTemperature(params.colorTemperature);
            setShadowSoftness(params.shadowSoftness || 0.5);
            setBright(params.sunBright);
            setAngle(params.azimuthAngle - 45);
            setAngleElevation(params.elevationAngle - 45);
            setSunLightCheck(+params.sunLightState === 1);
            return;
        }
        setAngle(210);
        setAngleElevation(-15);
        setTemperature(6500);
        setShadowSoftness(0.5);
        setBright(5);
        setSunLightCheck(true);
    };

    const onSunLightChange = (checked, e) => {
        isFromHDDActive.current = false;
        e.stopPropagation();

        setSunLightCheck(checked);
    };

    const onReset = e => {
        isFromHDDActive.current = false;

        e.stopPropagation();

        initLight();
    };

    const extra = (
        <div className="default-switch">
            <Switch checked={sunLightCheck} onChange={onSunLightChange} />
            <span onClick={onReset}>恢复默认</span>
        </div>
    );

    const [angle, setAngle] = useState(210);
    const [dragging, setDragging] = useState(false);

    const [angleElevation, setAngleElevation] = useState(-15);

    const handleMouseDown = e => {
        if (!sunLightCheck) return;
        setDragging(true);
    };

    const handleMouseMove = e => {
        if (dragging) {
            const element = document.getElementById('move-container');
            const containerRect = element.getBoundingClientRect();
            const centerX = containerRect.left + containerRect.width / 2;
            const centerY = containerRect.top + containerRect.height / 2;
            const mouseX = e.clientX;
            const mouseY = e.clientY;
            const _angle =
                Math.atan2(mouseY - centerY, mouseX - centerX) *
                    (180 / Math.PI) +
                135;
            isFromHDDActive.current = false;
            setAngle(_angle);
        }
    };

    const DragFn = throttle(handleMouseMove, 300);

    const onElevationSunMove = e => {
        if (draggingElevation) {
            const element = document.getElementById('move-container-elevation');
            const containerRect = element.getBoundingClientRect();
            const centerX = containerRect.right;
            const centerY = containerRect.bottom;
            const mouseX = e.clientX;
            const mouseY = e.clientY;
            let _angle =
                Math.atan2(mouseY - centerY, mouseX - centerX) *
                    (180 / Math.PI) +
                +135;
            if (_angle >= 45 && _angle < 225) {
                _angle = 45;
            }
            if (_angle > 225 && _angle < 360) {
                _angle = -45;
            }
            isFromHDDActive.current = false;
            setAngleElevation(_angle);
        }
    };

    const dragEleVationFn = throttle(onElevationSunMove, 0);

    const handleMouseUp = () => {
        setDragging(false);
    };

    const handleMouseDown1 = () => {
        if (!sunLightCheck) return;
        draggingElevation = true;
    };

    const handleMouseUp1 = () => {
        draggingElevation = false;
    };

    const documentMouseUp = () => {
        handleMouseUp();
        handleMouseUp1();
    };

    const isFromHDDActive = useRef(false);

    useEffect(() => {
        document.addEventListener('mouseup', documentMouseUp);
        document.addEventListener('mousemove', dragEleVationFn);

        window.noticeLightingList = function (params) {
            let objParams = JSON.parse(params);
            setLightList(objParams);
            const curLight = objParams.find(v => +v.active === 1);
            isFromHDDActive.current = true;
            setSelectMenu(curLight.id);
            initLight(curLight);
        };

        getCondition().then(res => {
            console.log('res', res);
            setLightNames(res.data.IesConfig);
        });

        return () => {
            document.removeEventListener('mouseup', documentMouseUp);
            document.removeEventListener('mousemove', dragEleVationFn);
        };
    }, []);

    const [temperature, setTemperature] = useState(6500);

    const [shadowSoftness, setShadowSoftness] = useState(0.5);

    const [bright, setBright] = useState(5);

    const onTemperatureChange = value => {
        isFromHDDActive.current = false;
        setTemperature(value);
    };

    const onShadowSoftnessChange = value => {
        isFromHDDActive.current = false;
        setShadowSoftness(value);
    };

    const onBrightChange = value => {
        isFromHDDActive.current = false;

        setBright(value);
    };

    const computedAngle = angle => {
        if (angle <= 180 && angle >= 0) {
            return angle;
        } else {
            return angle - 360;
        }
    };

    const isFirst = useRef(true);

    useEffect(() => {
        try {
            if (isFromHDDActive.current) return;

            if (isFirst.current) {
                isFirst.current = false;
                return;
            }

            const params = {
                temperature, // 色温
                shadowSoftness, // 阴影柔和度
                bright, // 亮度
                angle: parseInt(angle + 45), // 方位角
                angleElevation: parseInt(angleElevation + 45), // 俯仰角
                sunLightState: sunLightCheck ? 1 : 0, // 太阳光开关
                id: selectMenu,
                switchLight: switchLight.current, // 是否在切换布光方案
            };
            console.log('params', params);
            window.external.DispatchFun(
                'LeftPanel',
                'setLightingParams',
                JSON.stringify(params)
            );
            if (switchLight.current === 1) {
                switchLight.current = 0;
            }
        } catch (e) {}
    }, [
        temperature,
        shadowSoftness,
        bright,
        angle,
        angleElevation,
        sunLightCheck,
        selectMenu,
    ]);

    const IES_Lighting = lightNames.map((v, i) => {
        return (
            <div
                key={i}
                className="lighting-wrap lighting-wrap-ies"
                onMouseDown={e =>
                    handleLightMousedown(e, {
                        id: v.id,
                        type: 5,
                        name: v.name,
                        intensity: v.intensity,
                        iesFile: v.iesFile,
                    })
                }
                onMouseUp={handleLightMouseup}>
                <img src={v.thumbnail}></img>
                <div className="light-name">{v.name}</div>
            </div>
        );
    });

    const radianceLight = [
        <div
            key={0}
            className="lighting-wrap lighting-wrap-ies"
            onMouseDown={e =>
                handleLightMousedown(e, { id: 6, type: 6, name: '辉光' })
            }
            onMouseUp={handleLightMouseup}>
            <img
                src={
                    require(`@/assets/img/hdd/iesLight/huiguang.png`).default
                }></img>
            <div className="light-name">{'辉光'}</div>
        </div>,
    ];

    return (
        <div className="lighting">
            <div className="lighting-header">
                <Dropdown overlay={menu}>
                    <Space>
                        {lightList.find(v => v.id === selectMenu)?.name}
                        <DownOutlined />
                    </Space>
                </Dropdown>
            </div>
            <div className="lighting-content">
                <Collapse
                    bordered={false}
                    defaultActiveKey={['1', '2']}
                    expandIcon={({ isActive }) => (
                        <CaretRightOutlined rotate={isActive ? 90 : 0} />
                    )}
                    className="render-params-collapse"
                    expandIconPosition="right">
                    <Panel header="基础光源" key="1" className="base-light">
                        {baseLighting}
                    </Panel>
                    {versionFlag && (
                        <>
                            <Panel
                                header="IES光源"
                                key="3"
                                className="ies-light">
                                {IES_Lighting}
                            </Panel>
                            <Panel
                                header="辉光光源"
                                key="4"
                                className="ies-light">
                                {radianceLight}
                            </Panel>
                        </>
                    )}
                    <div className="split-line"></div>
                    <Panel
                        header="太阳光"
                        key="2"
                        extra={extra}
                        className="sun-lighting">
                        <div className="lighting-content-left-item color-temperature">
                            <div className="lighting-content-left-item-title color-temperature">
                                色温
                            </div>
                            <div className="lighting-content-left-item-slider slider-wrap-large">
                                <Slider
                                    min={2000}
                                    max={15000}
                                    step={1}
                                    marks={marks}
                                    value={temperature}
                                    disabled={!sunLightCheck}
                                    onChange={onTemperatureChange}
                                />
                                <InputNumber
                                    min={2000}
                                    max={15000}
                                    value={temperature}
                                    disabled={!sunLightCheck}
                                    onChange={onTemperatureChange}
                                    onPressEnter={e => e.target.blur()}
                                />
                                <div className="after-prefix">k</div>
                            </div>
                        </div>
                        <div className="lighting-content-left-item">
                            <div className="lighting-content-left-item-title">
                                阴影柔和度
                            </div>
                            <div className="lighting-content-left-item-slider slider-wrap">
                                <Slider
                                    min={0.1}
                                    max={2}
                                    step={0.1}
                                    marks={shadowMarks}
                                    value={shadowSoftness}
                                    disabled={!sunLightCheck}
                                    onChange={onShadowSoftnessChange}
                                />
                                <InputNumber
                                    min={0.1}
                                    max={2}
                                    step={0.1}
                                    value={shadowSoftness}
                                    disabled={!sunLightCheck}
                                    onChange={onShadowSoftnessChange}
                                    onPressEnter={e => e.target.blur()}
                                />
                            </div>
                        </div>
                        <div className="lighting-content-left-item">
                            <div className="lighting-content-left-item-title">
                                亮度
                            </div>
                            <div className="lighting-content-left-item-slider slider-wrap">
                                <Slider
                                    min={0}
                                    max={10}
                                    step={0.1}
                                    value={bright}
                                    disabled={!sunLightCheck}
                                    onChange={onBrightChange}
                                />
                                <InputNumber
                                    min={0}
                                    max={10}
                                    step={0.1}
                                    value={bright}
                                    disabled={!sunLightCheck}
                                    onChange={onBrightChange}
                                    onPressEnter={e => e.target.blur()}
                                />
                                {/* <div className="after-prefix">%</div> */}
                            </div>
                        </div>
                        <div className="split-line split-line-shin"></div>
                        <div className="sun-location-title">阳光位置</div>
                        <div className="azimuth-angle-wrap">
                            <div
                                className="azimuth-angle"
                                id="move-container"
                                onMouseMove={DragFn}>
                                <div className="container">
                                    <div
                                        id="draggable"
                                        className="draggable"
                                        style={{
                                            transform: `rotate(${angle}deg)`,
                                        }}>
                                        <span
                                            onMouseDown={handleMouseDown}
                                            className="sun-icon">
                                            <div
                                                className="tip"
                                                style={{
                                                    color: '#000',
                                                    transform: `rotate(${-angle}deg)`,
                                                }}>
                                                {computedAngle(
                                                    parseInt(angle + 45)
                                                ) + '°'}
                                            </div>
                                        </span>
                                    </div>
                                </div>
                                <div className="label-name">方位角</div>
                            </div>
                        </div>

                        <div className="azimuth-angle-wrap">
                            <div
                                className="azimuth-angle azimuth-angle1"
                                onMouseDown={e => {
                                    e.preventDefault();
                                }}>
                                <div className="overflow-container-wrap">
                                    <div
                                        className="container-wrap"
                                        id="move-container-elevation">
                                        <div className="container"></div>
                                    </div>
                                    <div
                                        id="draggable"
                                        className="draggable"
                                        style={{
                                            transform: `rotate(${angleElevation}deg)`,
                                        }}>
                                        <span
                                            onMouseDown={handleMouseDown1}
                                            className="sun-icon">
                                            <div
                                                className="tip"
                                                style={{
                                                    color: '#000',
                                                    transform: `rotate(${-angleElevation}deg)`,
                                                }}>
                                                {parseInt(angleElevation + 45) +
                                                    '°'}
                                            </div>
                                        </span>
                                    </div>
                                </div>
                                <div className="label-name">俯仰角</div>
                            </div>
                        </div>
                    </Panel>
                </Collapse>
            </div>
        </div>
    );
}
